// extracted by mini-css-extract-plugin
module.exports = {"textAreaContainer":"MultipleChoiceFreeText_textAreaContainer__2A8Sb","textarea":"MultipleChoiceFreeText_textarea__1WR93","hidden":"MultipleChoiceFreeText_hidden__ndDe_"};